import z from 'zod';
import {studyContentSchema} from './studyContentSchema';
import {studyStatusSchema} from './StudyStatus';

/** Writable fields for study (create/update). studyContent required when saving. */
export const studyWriteSchema = z.object({
  status: studyStatusSchema.optional(),
  studyContent: z.array(studyContentSchema),
});

export interface StudyWrite extends z.infer<typeof studyWriteSchema> {}
